/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
export const StringTable = [
  {
    "key": "sampleStrKey",
    "en": "Sample"
  }
]


// WEBPACK FOOTER //
// ./src/StringTable.js